module.exports = __webpack_public_path__ + "media/images/icon/icon-facebook-5330c0c39398641e1fbee759ce306165.svg";